module.exports = __webpack_public_path__ + "img/finish_point_512x512.b9b75133.png";